<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file carousel_3d.vue is part of event_pass_client.dev.               -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - carousel_3d.vue can not be copied and/or distributed                      -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<template>
    <div>
        <carousel-3d :count="slides.length"
                     :controls-visible="slideParams.controls_visible"
                     :width="slideParams.width"
                     :height="slideParams.height"
                     :autoplay="slideParams.autoplay"
                     :disable3d="slideParams.disable3d"
                     :space="slideParams.space"
                     :perspective="slideParams.perspective"
                     :display="slideParams.display"
                     :loop="slideParams.loop"
                     :animation-speed="slideParams.animation_speed"
                     :dir="slideParams.dir"
                     :border="slideParams.border"
                     :start-index="slideParams.start_index"
                     :inverse-scaling="slideParams.inverse_scaling">
            <slide v-for="(slide, i) in slides"
                   :index="i"
                   style="top:0 !important;"
                   :key="slide.id"
                   :style="addImage(slide)">

                <a :href="createLink(slide[path.data])"
                   class="carousel-3d-slide--contents"
                   :class="slideParams.jumboClass">
                    <span class="carousel-3d-slide--contents-jumbo"
                          :class="slideParams.jumboClass"
                          v-html="getDate(slide.start_date)"></span>
                    <h1 :class="slideParams.jumboClass">{{createTitle(slide)}}</h1>
                </a>
            </slide>
        </carousel-3d>
    </div>
</template>

<script>
	/**
	 * @link https://wlada.github.io/vue-carousel-3d/guide/
	 */
	// add imports here
	import {Carousel3d, Slide} from 'vue-carousel-3d';
	import axios from 'axios';
	import {mergeObjectDeep} from '../../../tools/objects.arrays';
	import {getDate, getTime} from '../../../../../../app/Shared/Resources/Assets/js/helpers/format.date';
	import {createUrlFromData} from '../../../tools/format.data_url';

	/**
	 <slide v-for="(slide,i) in items" :index="i" :key="slide.id">
	 <h1>{{slide.slug}}</h1>
	 </slide>
	 */
	export default {
		components: {
			'carousel-3d': Carousel3d,
			'slide': Carousel3d.components.Slide
		},
		props: ['content'],
		created() {
//			console.log('Carousel3d',Carousel3d);
		},
		mounted() {
			this.url = this.content.url;
			this.path = mergeObjectDeep(this.path, this.content.path);

			if (this.content.slideParams) {
				this.slideParams = mergeObjectDeep(this.slideParams, this.content.slideParams);
			}

			if (this.slideParams.width < 500) {
				this.slideParams.jumboClass = this.classSmall;
			}
			this.readDataSet();
		},
		data() {
			return {
				items: {},
				slides: [],
				classSmall: 'small-slide',
				slideParams: {
					jumboClass: null,
					count: 5,
					controls_visible: true,
					width: 1024,
					height: 270,
					autoplay: true,
					disable3d: false,
					space: 300,
					perspective: 35,
					display: 5,
					loop: true,
					animation_speed: 500,
					dir: 'rtl',
					border: 1,
					start_index: 0,
					inverse_scaling: 300,
				},
				url: '',
				params: {},
				lang: 'en_GB',

				path: {
					data: ''
				},

			}
		},
		methods: {
			readDataSet() {
				let _this = this;
				axios({
					method: 'get',
					url: _this.url,
					params: _this.params

				}).then((response) => {
					if (response.status !== 200) {
						console.error('No response');
						return false;
					}
//					console.log('response.data',response.data);
					_this.slides = response.data;
				});
			},
			createLink(table_data) {
				let link = createUrlFromData(table_data, this.path.route);
				console.log('createUrlFromData(table_data, this.path.route)', link);
				return link;

			},
			getDate(date) {
				let dateObject = getDate(date, 'tiny', true);

				return `<span class="day">${dateObject['day']}</span> <span class="month">${dateObject['month']}</span> <span class="year">${dateObject['year']}</span>`;

			},
			addImage(slide) {
				return `background-image:url(${slide[this.path.data].images[0]})`
			},
			debug(i) {
				console.log('i', i);
			},
			onAfterSlideChange(index) {
				console.log('@onAfterSlideChange Callback Triggered', 'Slide Index ' + index)
			},
			onBeforeSlideChange(index) {
				console.log('@onBeforeSlideChange Callback Triggered', 'Slide Index ' + index)
			},
			onLastSlide(index) {
				console.log('@onLastSlide Callback Triggered', 'Slide Index ' + index)
			},
			createLink(table_data) {
				return createUrlFromData(table_data, this.path.route);

			},
			createTitle(article) {
				return article[this.path.data].lang[this.lang].title;
			},
		}
	}
</script>

<style scoped>

    /*.carousel-3d-container .carousel-3d-slide {*/
    /*padding: 20px;*/
    /*padding-left:0;*/

    /*}*/

    /*.carousel-3d-container .carousel-3d-slide .title {*/
    /*font-size: 22px;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/carousel/carousel_3d.vue